import {
  IMediaManagerSDKRequestOptions,
  MediaManagerSDKAnyItem,
  MediaManagerSDKCursor,
  MediaManagerSDKResponse,
  MediaManagerSDKResponseData,
} from '../media-manager-sdk';

export type TLoadItemsFn = (
  folderId: string,
  options: IMediaManagerSDKRequestOptions,
) => MediaManagerSDKResponse<MediaManagerSDKAnyItem[]>;
export type TSearchItemsFn = (
  folderId: string,
  searchQuery: string,
  options: IMediaManagerSDKRequestOptions,
) => MediaManagerSDKResponse<MediaManagerSDKAnyItem[]>;

export class DataProvider {
  protected isCancelled: boolean = false;
  protected cursor: MediaManagerSDKCursor = null;
  protected didLoadItems: boolean = false;

  constructor(protected loadItemsFn: TLoadItemsFn | TSearchItemsFn) {}

  reset() {
    this.cursor = null;
    this.didLoadItems = false;
  }

  cancel() {
    this.isCancelled = true;
  }

  async loadItems(folderId: string, options: IMediaManagerSDKRequestOptions = {}) {
    const loadItemsOptions = {
      ...options,
      paging: {
        ...options.paging,
        cursor: this.cursor,
      },
    };

    let response: MediaManagerSDKResponseData<MediaManagerSDKAnyItem[]>;

    try {
      response = options.searchQuery
        ? await (this.loadItemsFn as TSearchItemsFn)(folderId, options.searchQuery, loadItemsOptions)
        : await (this.loadItemsFn as TLoadItemsFn)(folderId, loadItemsOptions);

      if (this.isCancelled) {
        return Promise.reject(new Error('cancelled'));
      }
    } catch (error) {
      return Promise.reject(error);
    } finally {
      this.didLoadItems = true;
    }

    this.setCursor((response.paging && response.paging.cursor) || null);

    return response;
  }

  get hasMoreItems() {
    return !this.didLoadItems || this.cursor !== null;
  }

  protected setCursor(cursor: MediaManagerSDKCursor) {
    this.cursor = cursor;
  }
}
